import type { GetResourceEventsInput, ResourceEventCreateDto, ResourceEventDto, ResourceEventUpdateDto, ResourceEventWithNavigationPropertiesDto } from './models';
import { RestService } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { LookupDto, LookupRequestDto } from '../shared/models';

@Injectable({
  providedIn: 'root',
})
export class ResourceEventService {
  apiName = 'Analysis';

  create = (input: ResourceEventCreateDto) =>
    this.restService.request<any, ResourceEventDto>({
      method: 'POST',
      url: `/api/analysis/resource-events`,
      body: input,
    },
    { apiName: this.apiName });

  delete = (id: string) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/analysis/resource-events/${id}`,
    },
    { apiName: this.apiName });

  get = (id: string) =>
    this.restService.request<any, ResourceEventDto>({
      method: 'GET',
      url: `/api/analysis/resource-events/${id}`,
    },
    { apiName: this.apiName });

  getAUserLookup = (input: LookupRequestDto) =>
    this.restService.request<any, PagedResultDto<LookupDto<string>>>({
      method: 'GET',
      url: `/api/analysis/resource-events/a-user-lookup`,
      params: { filter: input.filter, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });

  getEventTypeLookup = (input: LookupRequestDto) =>
    this.restService.request<any, PagedResultDto<LookupDto<string>>>({
      method: 'GET',
      url: `/api/analysis/resource-events/event-type-lookup`,
      params: { filter: input.filter, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });

  getList = (input: GetResourceEventsInput) =>
    this.restService.request<any, PagedResultDto<ResourceEventWithNavigationPropertiesDto>>({
      method: 'GET',
      url: `/api/analysis/resource-events`,
      params: { filterText: input.filterText, eventDateMin: input.eventDateMin, eventDateMax: input.eventDateMax, resourceId: input.resourceId, eventTypeId: input.eventTypeId, aUserId: input.aUserId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });

  getResourceLookup = (input: LookupRequestDto) =>
    this.restService.request<any, PagedResultDto<LookupDto<string>>>({
      method: 'GET',
      url: `/api/analysis/resource-events/resource-lookup`,
      params: { filter: input.filter, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });

  getWithNavigationProperties = (id: string) =>
    this.restService.request<any, ResourceEventWithNavigationPropertiesDto>({
      method: 'GET',
      url: `/api/analysis/resource-events/with-navigation-properties/${id}`,
    },
    { apiName: this.apiName });

  update = (id: string, input: ResourceEventUpdateDto) =>
    this.restService.request<any, ResourceEventDto>({
      method: 'PUT',
      url: `/api/analysis/resource-events/${id}`,
      body: input,
    },
    { apiName: this.apiName });

  constructor(private restService: RestService) {}
}
